document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.add-to-cart-btn');

    buttons.forEach(button => {
        button.addEventListener('click', function() {
            const variantId = button.getAttribute('data-variant-id');
            addToCart(variantId);
        });
    });

    function addToCart(variantId) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1
                    }
                ]
            })
        })
        .then(response => response.json())
        .then(data => {
                document.dispatchEvent(
            new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
          );
  document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, cancelable: false })
    );
      })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function openCartDrawer() {
      alert("item added");
        // Assuming you have a function to open the cart drawer
        // This could be a custom function depending on your theme
        const cartDrawer = document.querySelector('.cart-link');
        if (cartDrawer) {
            cartDrawer.click();
          
        }
    }
 
});

    // Function to handle the click event on .show_dekstop buttons
    document.querySelectorAll('.show_dekstop').forEach(function(button) {
        button.addEventListener('click', function() {
            // Remove active class from all .sizevalue divs
            document.querySelectorAll('.sizevalue').forEach(function(sizevalue) {
                sizevalue.classList.remove('active');
                sizevalue.style.opacity = 0;
            });

            // Get the product ID from the current button's parent div
            var parentDiv = button.closest('div[id^="class_"]');
            var productId = parentDiv.id.split('_')[1];
            
            // Add the active class to the corresponding .sizevalue div
            var sizevalueDiv = document.getElementById('sizevalue' + productId);
            sizevalueDiv.classList.add('active');
            sizevalueDiv.style.opacity = 1;
        });
    });
    

    // Function to handle the mouseleave event on .image-cont divs
    document.querySelectorAll('.image-cont').forEach(function(imageCont) {
        imageCont.addEventListener('mouseleave', function() {
            // Remove active class from all .sizevalue divs
            document.querySelectorAll('.sizevalue').forEach(function(sizevalue) {
                sizevalue.classList.remove('active');
                sizevalue.style.opacity = 0;
            });
        });
    });

document.addEventListener('DOMContentLoaded', function() {
    const mobileButtons = document.querySelectorAll('.show_mobile');
    const desktopButtons = document.querySelectorAll('.show_dekstop');
    const removeButtons = document.querySelectorAll('[id^=remove_]');

    let activeId = null;

    mobileButtons.forEach(button => {
        button.addEventListener('click', function() {
            const productId = this.parentNode.id.split('_')[1];
            const sizeValueDiv = document.getElementById(`sizevalue${productId}`);
            
            if (activeId && activeId !== productId) {
                document.getElementById(`sizevalue${activeId}`).classList.remove('active');
            }

            sizeValueDiv.classList.add('active');
            activeId = productId;
        });
    });

    desktopButtons.forEach(button => {
        button.addEventListener('click', function() {
            if (activeId) {
                document.getElementById(`sizevalue${activeId}`).classList.remove('active');
                activeId = null;
            }
        });
    });

    removeButtons.forEach(button => {
        button.addEventListener('click', function() {
            const productId = this.id.split('_')[1];
            document.getElementById(`sizevalue${productId}`).classList.remove('active');
            if (activeId === productId) {
                activeId = null;
            }
        });
    });
});